import { render, staticRenderFns } from "./WebSearch.vue?vue&type=template&id=108e1ed5"
import script from "./WebSearch.vue?vue&type=script&lang=js"
export * from "./WebSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports